import { render, staticRenderFns } from "./aztecempire.vue?vue&type=template&id=67cffca0&scoped=true"
import script from "./aztecempire.vue?vue&type=script&lang=js"
export * from "./aztecempire.vue?vue&type=script&lang=js"
import style0 from "./aztecempire.vue?vue&type=style&index=0&id=67cffca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cffca0",
  null
  
)

export default component.exports